import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import {
  Chip,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  OpenInNew as OpenInNewIcon, 
} from '@material-ui/icons';

import { ResourcePolyIcon } from '.';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '8px',
    whiteSpace: 'normal',
    height: 'auto',
  },
  label: {
    // display: 'flex',
    // flexGrow: 2,
    paddingTop: '4px',
    paddingBottom: '4px',
    width: 'calc(100% - 58px)',
    whiteSpace: 'normal',
  },
  info: {
    display: 'flex',
    flexFlow: 'column',
    //overflow: 'hidden',
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
  },
  typography: {
  }
}));

export default function ResourceChip(props) {
  const { id, type, name, description, extLink, linked, adorned, maxWidth } = props;
  const classes = useStyles();
  const [ navToResource, setNavToResource ] = React.useState(null);

  const handleExtLink = () => {
    if(extLink && extLink.href) {
      window.open(extLink.href,"_blank");
    }
  };

  const handleClick = () => {
    if(linked) {
      setNavToResource(id);
    }
  };

  if(navToResource) {
    return <Redirect push to={"/Resources/"+type+"s/"+navToResource} />;  
  }
  
  const ExtLinkIcon=(extLink && extLink.icon)?extLink.icon:null;
  return (
      <Chip
        classes={{ root: classes.root, label: classes.label }}
        variant="outlined"
        icon={adorned?<ResourcePolyIcon type={type} />:null}
        label={
          <div className={classes.info}>
            <div className={classes.name}>
              <Typography className={classes.typography} variant='inherit' color='primary'>
                {name || id}
              </Typography>
            </div>
            <div className={classes.description}>
              <Typography className={classes.typography} variant='inherit'>
                {description}
              </Typography>
            </div>
          </div>
        }
        onClick={linked?handleClick:null}
        onDelete={extLink?handleExtLink:null}
        deleteIcon={extLink?(extLink.icon?<ExtLinkIcon {...extLink.iconProps}/>:<OpenInNewIcon />):null}
        style={{ maxWidth }}
      />
  );
}

ResourceChip.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  description: PropTypes.string,
  linked: PropTypes.bool.isRequired,
  adorned: PropTypes.bool.isRequired,
  extLink: PropTypes.object,
  maxWidth: PropTypes.string,
};

ResourceChip.defaultProps = {
  variant: 'inherit',
  linked: true,
  adorned: false,
  //maxWidth: '200px',
};